/**
 * @file portalPageLinks.js
 * @description Recognizes portal page view paths (/portal-pages/{id}) and builds the router
 * state PortalPageView needs when such a path is opened directly, e.g. from an email link.
 */

const PORTAL_PAGE_PATH_PATTERN = /^\/portal-pages\/(\d+)\/?$/;

export function getPortalPageIdFromPath(pathname) {
    const portalMatch =
        typeof pathname === 'string'
            ? pathname.match(PORTAL_PAGE_PATH_PATTERN)
            : null;

    return portalMatch ? Number(portalMatch[1]) : null;
}

export function isPortalPageViewPath(pathname) {
    return getPortalPageIdFromPath(pathname) !== null;
}

export function buildPortalDeepLinkState(pathname) {
    const portalPageId = getPortalPageIdFromPath(pathname);

    return portalPageId === null ? null : { navigationStack: [portalPageId] };
}
